/*
  SalonID-winkelwagen (okt 2026): de teller per regel in dozen, combipacks
  of stuks. Een klik past het getal direct aan; na een korte pauze gaat de
  wijziging naar Shopify (cart/change voor één regel, cart/update met de
  regelsleutels voor beide helften van een combipack) en ververst cart.js
  de lade of pagina. Lukt het niet, dan springt de teller terug en komt de
  melding van Shopify onder de regel.
*/
(function () {
  if (customElements.get('sid-cart-qty')) return;

  var routes = window.routes || {};

  class SidCartQty extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.original = parseInt(this.dataset.count, 10) || 1;
      this.count = this.original;
      this.step = parseInt(this.dataset.step, 10) || 1;
      this.mult = parseInt(this.dataset.mult, 10) || 1;
      this.min = this.step;
      this.countEl = this.querySelector('[data-count]');
      this.unitEl = this.querySelector('[data-unit]');
      this.minus = this.querySelector('[data-dir="-1"]');
      var item = this.closest('.sid-cart-item');
      this.piecesEl = item ? item.querySelector('[data-sid-pieces]') : null;
      this.querySelectorAll('button[data-dir]').forEach((button) => {
        button.addEventListener('click', () => this.change(parseInt(button.dataset.dir, 10)));
      });
      this.render();
    }

    change(dir) {
      var next = this.count + dir * this.step;
      if (next < this.min) return;
      this.count = next;
      this.lastDir = dir;
      this.render();
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.apply(), 450);
    }

    render() {
      this.countEl.textContent = this.count;
      this.unitEl.textContent = this.count === 1 ? this.dataset.one : this.dataset.other;
      if (this.minus) this.minus.disabled = this.count - this.step < this.min;
      if (this.piecesEl && this.dataset.pieces) {
        this.piecesEl.textContent = this.dataset.pieces.replace('[n]', this.count * this.mult);
      }
    }

    async apply() {
      if (this.count === this.original) return;
      var cartItems = this.closest('cart-items');
      if (!cartItems) return;
      var line = this.dataset.line;
      var hadFocus = this.contains(document.activeElement);
      var url;
      var body = { sections: 'main-cart', sections_url: window.location.pathname };

      if (this.dataset.keys) {
        var keys = this.dataset.keys.split(',');
        var qtys = this.dataset.qtys.split(',').map(Number);
        var updates = {};
        keys.forEach((key, i) => {
          updates[key] = Math.round((qtys[i] / this.original) * this.count);
        });
        url = routes.cart_update_url || '/cart/update';
        body.updates = updates;
      } else {
        url = routes.cart_change_url || '/cart/change';
        body.line = parseInt(line, 10);
        body.quantity = this.count * this.mult;
      }

      cartItems.classList.add('is-processing');
      try {
        var response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        var json = await response.json();
        if (!response.ok || !json.sections || !json.sections['main-cart']) {
          throw json.description || json.message || json.errors || '';
        }
        document.dispatchEvent(new CustomEvent('cart:update', { detail: json }));
        var html = new DOMParser().parseFromString(json.sections['main-cart'], 'text/html');
        cartItems.updateCartSections(html);
        if (hadFocus) {
          var again = cartItems.querySelector('sid-cart-qty[data-line="' + line + '"] button[data-dir="' + this.lastDir + '"]');
          if (again && !again.disabled) again.focus();
          else if (again) again.parentElement.querySelector('button:not([disabled])')?.focus();
        }
      } catch (message) {
        this.count = this.original;
        this.render();
        if (typeof cartItems.updateLiveRegions === 'function') {
          cartItems.updateLiveRegions(line, typeof message === 'string' && message ? message : this.dataset.error || '');
        }
      } finally {
        cartItems.classList.remove('is-processing');
      }
    }
  }

  customElements.define('sid-cart-qty', SidCartQty);
})();
